import type { FeatureFlagConfig } from '@platform/client/features/feature-config';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    DATA_EXPLORER_IMPROVED_SEARCH?: boolean;
    EVENT_LOG_EVENTS_SOURCE?: boolean;
    DATA_EXPLORER_VISUALIZATION?: boolean;
  }
}

export default {
  featureFlags: {
    DATA_EXPLORER_IMPROVED_SEARCH: undefined,
    // S2CX-2980
    EVENT_LOG_EVENTS_SOURCE: undefined,
    // S2CX-354
    DATA_EXPLORER_VISUALIZATION: true,
  },
} satisfies FeatureFlagConfig;
